// extracted by mini-css-extract-plugin
module.exports = {"ask":"e__4","title":"e_04","text":"e_14","cta":"e_24"};